// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Button from "elevate-ui/Button";
import { withGlobalContext } from "../common/GlobalContext";
import Details from "../listing-detail/Details";
import type { $BlogPost, CompliantListingType } from "flow/types";
import Disclaimer from "../listing-detail/Disclaimer";

type Props = {
  classes: Object,
  className: string,
  listing: CompliantListingType,
  post: $BlogPost,
  image: string,
};

const BlogDisclaimer = ({ listing }) => (
  <div style={{ marginTop: "48px" }}>
    <Disclaimer
      compliance={listing.compliance}
      listing={listing}
      complianceKey="blogListingDisclaimer"
    />
  </div>
);

const renderBlogDisclaimer = (listing) => {
  if (listing.compliance && listing.compliance.blogListingDisclaimer) {
    return <BlogDisclaimer listing={listing} />;
  }
  return;
};

const BlogListing = ({ classes, className, image, listing }: Props) => {
  const watermarkQuery =
    listing && listing.compliance && listing.compliance.photoWatermark
      ? `&mark=${listing.compliance.photoWatermark}&markscale=${
          listing.compliance.markScale
        }`
      : "";

  if (!listing) {
    return (
      <div className={classNames(classes.root, className)}>
        Sorry, the selected listing could not be found.
      </div>
    );
  }

  const correctedImage = image.includes("?") ? `${image}&` : `${image}?`;

  return (
    <div className={classNames(classes.root, className)}>
      <a
        href={
          listing.detailUrl
            ? listing.detailUrl
            : `/listings/${listing.detailsUrlSlug}`
        }
        className={classes.photo}
      >
        <img
          className={classes.img}
          srcSet={`
            ${correctedImage}auto=format&fit=crop&w=700&h=320&or=0&dpr=1${watermarkQuery} 1x,
            ${correctedImage}auto=format&fit=crop&w=700&h=320&or=0&dpr=2${watermarkQuery} 2x,
            ${correctedImage}auto=format&fit=crop&w=700&h=320&or=0&dpr=3${watermarkQuery} 3x,
          `}
          sizes="280px"
          src={`${correctedImage}fit=crop&w=280&h=160&or=0${watermarkQuery}`}
          alt={listing.fullAddress}
        />
      </a>
      <Details
        classes={{ publicRemarks: classes.publicRemarks }}
        listing={listing}
        compliance={listing.compliance}
      />
      <Button
        element="a"
        href={
          listing.detailUrl
            ? listing.detailUrl
            : `/listings/${listing.detailsUrlSlug}`
        }
        style={{ marginTop: "48px" }}
      >
        Learn more about this property
      </Button>
      {renderBlogDisclaimer(listing)}
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  photo: {
    display: "flex",
    width: "100%",
    marginBottom: theme.spacing.unit * 2,
  },
  img: {
    maxWidth: "100%",
    objectFit: "contain", // Mobile
  },
  publicRemarks: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "700px",
    color: theme.colors.gray["900"],
    fontSize: "16px",
    lineHeight: "1.6",
    paddingTop: theme.spacing.unit,
  },
}))(withGlobalContext(BlogListing));
